<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="md:col-12 lg:col-12 col-12">
      <app-detalle-tercero *ngIf="tercero && tercero.idTercero" [third]="tercero" [view]="false"
                           [edit]="false"
                           [clasification]="false"></app-detalle-tercero>
    </div>
  </div>
  <div class="grid">
    <div class="col-12">
      <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
        <p-accordionTab header="{{ 'SUCURSALES.LBL_SUCURSAL' | translate }}" [selected]="tabSeleccionado === 'INFO'">
          <div class="grid" *ngIf="addinglocation">
            <div class="col-12 md:col-12 lg:col-12">
              <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idFormSucursal" name="nomFormSucursal">
                <div class="grid form-group">
                  <div class="col-12 md:col-4 lg:col-4">
                    <div class="div-form">
                      <label>* {{ 'SUCURSALES.LBL_CODIGO' | translate }}</label>
                        <input type="text" pInputText id="codigo"
                               name="nomCodigo"
                               autocomplete="off"
                               formControlName="codigo"
                               maxlength="8"
                               codigos-reactive
                        >
                        <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                          {{ 'SUCURSALES.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                        </div>
                    </div>
                  </div>
                  <div class="col-12 md:col-4 lg:col-4">
                    <div class="div-form">
                      <label>* {{ 'SUCURSALES.LBL_NOMBRE' | translate }}</label>
                      <input type="text" pInputText id="idNombre"
                             name="nomNombre"
                             autocomplete="off"
                             formControlName="nombre"
                             [maxlength]="150"
                             capitalize-reactive
                      >
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                        {{ 'SUCURSALES.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 md:col-4 lg:col-4">
                    <div class="div-form">
                      <label>{{ 'SUCURSALES.LBL_ALIAS' | translate }}</label>
                      <input type="text" pInputText id="alias"
                             name="nomAlias"
                             autocomplete="off"
                             formControlName="alias"
                             maxlength="150"
                      >
                    </div>
                  </div>
                </div>
                <div class="grid form-group">
                  <div class="col-12 md:col-4 lg:col-4">
                    <div class="div-form">
                      <label>* {{ 'SUCURSALES.LBL_ESTRUCTURAFISICA' | translate }}</label>
                      <p-dropdown disableTab  id="idOficinaVirtual" name="nomOficinaVirtual" [options]="lisOficinaVirtual"
                                  placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                                   formControlName="idEstructuraFisica"
                                  emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                  emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                  optionValue="value"
                                  optionLabel="label"
                      ></p-dropdown>
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idEstructuraFisica.invalid">
                        {{ 'SUCURSALES.LBL_ESTRUCTURAFISICA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 md:col-4 lg:col-4">
                    <div class="div-form">
                      <label>* {{ 'SUCURSALES.LBL_CUPOVALOR' | translate }}</label>
                      <input type="text" pInputText id="idCupoValor"
                             name="nomCupoValor"
                             autocomplete="off"
                             formControlName="cupoValor"
                             [maxlength]="20"
                             currencyMask
                             [options]="{ prefix: '$ ', thousands: appSettingService.separadorMiles, decimal: appSettingService.separadorDecimales, align: 'left', allowNegative:false, precision : 0 }"
                      >
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.cupoValor.invalid">
                        {{ 'SUCURSALES.LBL_CUPOVALOR' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 md:col-4 lg:col-4">
                    <div class="div-form">
                      <label>* {{ 'SUCURSALES.LBL_CUPOCREDITO' | translate }}</label>
                      <input type="text" pInputText id="idCupoCredito"
                             name="nomCupoCredito"
                             autocomplete="off" [minimo]="1"
                             formControlName="cupoCredito"
                             [maxlength]="5"
                             numero-entero-reactive
                      >
                      <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.cupoCredito.invalid">
                        {{ 'SUCURSALES.LBL_CUPOCREDITO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="grid form-group">
                  <div class="col-12 md:col-8 lg:col-8">
                    <div class="div-form">
                      <label>* {{'ALIADOSUSUARIOS.LBL_DIRECCIONNEGOCIO' | translate }}</label>
                      <textarea id="idDireccion" name="nomDireccion" pInputTextarea rows="2" required
                                formControlName="direccion"
                                class="falso-combo-texto"></textarea>
                      <div class="p-message p-messages-error p-corner-all"
                           *ngIf="submitted && (!f.direccion.value || f.direccion.value === '')">
                        {{ 'ALIADOSUSUARIOS.LBL_DIRECCIONNEGOCIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 md:col-4 lg:col-4 flex align-items-center mt-3">
                    <button style="width: 100%" pButton icon="fa fa-plus" label="{{'BTN_EDITARDIRECCION' | translate }}"
                            (click)="toggleform()"></button>
                  </div>
                </div>

                <div class="grid form-group">
                  <div class="col-12 md:col-4 lg:col-4">
                    <div class="div-form">
                      <label>{{ 'ALIADOSUSUARIOS.LBL_UBICACION' | translate }}</label>
                      <label *ngIf="carMunicipio"><i class="fa fa-refresh fa-spin fa-fw"></i></label>
                      <label *ngIf="!carMunicipio" class="falso-combo-texto">{{ municipio ? municipio.descripcionDivisonPolitica: null}}</label>
                    </div>
                  </div>
                  <div class="col-12 md:col-4 lg:col-4">
                    <p-checkbox label="{{ 'SUCURSALES.LBL_PRINCIPAL' | translate}}" binary="true"
                                id="idPrincipal"
                                name="nomPrincipal"
                                formControlName="indicadorPrincipal"></p-checkbox>
                  </div>
                  <div class="col-12 md:col-4 lg:col-4">
                    <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                                id="idHabilitado"
                                name="nomHabilitado"
                                formControlName="indicadorHabilitado"></p-checkbox>
                  </div>
                </div>
                <div class="grid form-footer-buttons">
                  <div class="form-group col-12">
                    <div *ngIf="!guardando">
                      <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                      <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                              type="submit"
                              pButton></button>
                    </div>
                    <div *ngIf="guardando">
                      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                      <span>{{'LBL_GUARDANDO' | translate }}</span>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div *ngIf="!addinglocation">
            <localizaciones-app [parentTitle]="('LBL_UBICACION' | translate)" (dismiss)="toggleform()" (create)="bindLocation($event)"
                                [localizacion]="localizacion"></localizaciones-app>
          </div>
        </p-accordionTab>
        <p-accordionTab header="{{ 'SUCURSALES.LBL_CUPOS' | translate }}" [selected]="tabSeleccionado === 'CUPOS'"
                        [disabled]="!sucursal">
          <app-aliados-sucursales-cupos [sucursal]="sucursal" *ngIf="sucursal && sucursal.idAliadoSucursal"></app-aliados-sucursales-cupos>
        </p-accordionTab>
        <p-accordionTab header="{{ 'SUCURSALES.LBL_USUARIOS' | translate }}" [selected]="tabSeleccionado === 'USUARIOS'"
                        [disabled]="!sucursal">
          <app-aliados-usuarios [sucursal]="sucursal" *ngIf="sucursal && sucursal.idAliadoSucursal"></app-aliados-usuarios>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar(false)"></button>
    </div>
  </div>
</div>
<p-confirmDialog #cd key="sucursal">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>


